import React, { Component } from 'react';
import './../../assets/css/App.css';

class MissingPage extends Component {
    render() {
        return (
            <div>
                <div style={{"textAlign": "center"}}>
                    <span>404 Page not found </span>
                </div>
            </div>
        );
    }
}

export default MissingPage;
